import { Component, OnChanges, Input } from "@angular/core";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
declare const BrandVars;

@Component({
	selector: "app-fleet-comparison",
	templateUrl: "./fleet-comparison.component.html",
	styleUrls: ["./fleet-comparison.component.scss"]
})
export class FleetComparisonComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;

	public brand = BrandVars;
	public boxPlotOptions: Highcharts.Options;
	public plotError: string;

	constructor(public api: ApiService, public charting: ChartingService) { }

	async ngOnChanges() {
		this.boxPlotOptions = undefined;
		this.plotError = undefined;
		try {
			const comparison = await this.api.GetFleetCompare(this.asset.asset_id, this.component.id);
			if (comparison.length === 0) {
				throw new Error("No valid assets to compare");
			}
			this.boxPlotOptions = this.charting.BoxPlotDefaults("HIs", comparison.map(item => item.asset_name), comparison.map(item => item.stats), comparison.map(item => item.outliers), AssemblyConfig.HumsHiThreshold.Warning, AssemblyConfig.HumsHiThreshold.Alarm);
		} catch (err) {
			if (err.message) {
				this.plotError = err.message;
			} else {
				this.plotError = "Couldn't load fleet comparison";
			}
		}
	}
}
